<template>
  <div class="DefaultBlockContent" :class="{ useCheckIconBullets }">
    <PortableText :value="blocks" :components="serializerComponents" />
  </div>
</template>

<script>
import { h, markRaw } from 'vue'

import CtaButton from '../../button-styles/CtaButton.vue'
import UnstyledCta from '../../button-styles/UnstyledCta.vue'
import BlockContentIconList from './BlockContentIconList.vue'

const serializerComponents = {
  types: {
    cta: ({ value }) => h(CtaButton, { text: value.text, action: value.action, class: 'ctaButton --dark-blue' }),
    iconList: markRaw(BlockContentIconList),
  },
  marks: {
    link: ({ text, value }) => h('a', { href: value.href, target: value.blank && '_blank' }, text),
    // NOTE: as of 26 Feb 2025, 'actionLink' is used in exactly one place in the entire site, which is the US
    // "Contact us" page (contactPage/8ae2e0e7-8328-406d-a5e7-429a2337ad11)
    actionLink: ({ text, value }) => h(UnstyledCta, { action: value.action, class: 'actionLink' }, text),
  },
}

export default {
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
    useCheckIconBullets: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { serializerComponents }
  },
}
</script>

<style scoped>

.DefaultBlockContent {
  font-weight: normal;
  color: var(--text-color, var(--text-color-dark));
}

.DefaultBlockContent:deep(h2),
.DefaultBlockContent:deep(h3),
.DefaultBlockContent:deep(h4),
.DefaultBlockContent:deep(h5),
.DefaultBlockContent:deep(h6) {
  color: var(--heading-color, var(--text-color-black));
  font-weight: 600;
  line-height: 1.2;
}

.DefaultBlockContent:deep(* + h2),
.DefaultBlockContent:deep(* + h3),
.DefaultBlockContent:deep(* + h4),
.DefaultBlockContent:deep(* + h5),
.DefaultBlockContent:deep(* + h6) {
  margin-top: var(--spacing-10);
}

.DefaultBlockContent:deep(* + p) {
  margin-top: var(--spacing-6);
}

.DefaultBlockContent:deep(* + ul) {
  margin-top: var(--spacing-6);
}

.DefaultBlockContent:deep(* + ol) {
  margin-top: var(--spacing-6);
}

.DefaultBlockContent.useCheckIconBullets:deep(ul) {
  list-style: none;
}

.DefaultBlockContent.useCheckIconBullets:deep(ul li) {
  background-image: var(--bullet-image, url('../../../assets/bullets/bullet-blue.svg'));
  background-position: 0 4px;
  background-repeat: no-repeat;
  padding-left: 28px;
}

.DefaultBlockContent.useCheckIconBullets:deep(ul li + li) {
  margin-top: var(--spacing-0);
}

.DefaultBlockContent:deep(ul),
.DefaultBlockContent:deep(ol) {
  padding-left: 1.5rem;
  line-height: 1.5;
}

.DefaultBlockContent:deep(ul) {
  list-style: disc;
}

.DefaultBlockContent:deep(ol) {
  list-style: decimal;
}

.DefaultBlockContent:deep(ol li + li) {
  margin-top: var(--spacing-4);
}

.DefaultBlockContent:deep(a:not(.ctaButton)),
.DefaultBlockContent:deep(.actionLink) {
  text-decoration: underline;
}

.DefaultBlockContent:deep(a:not(.ctaButton):hover),
.DefaultBlockContent:deep(.actionLink:hover) {
  color: var(--text-link-hover-color, var(--brand-color));
}

.DefaultBlockContent:deep(.ctaButton) {
  margin-top: var(--spacing-5);
}

@media (--screen-lg) {

  .DefaultBlockContent:deep(ul li) {
    background-position: 0 6px;
  }
}
</style>
